import { useEffect, useState } from "react"
import { arrayOf, bool, func, number, shape, string } from "prop-types"
import { TextInput } from "@planningcenter/doxy-web"

import FieldLabel from "../FieldLabel"

DropdownField.propTypes = {
  field: shape({
    attributes: shape({
      description: string,
      label: string.isRequired,
      required: bool.isRequired,
      settings: shape({
        other: bool,
      }),
    }),
    id: string.isRequired,
    options: arrayOf(
      shape({
        attributes: shape({
          label: string.isRequired,
          sequence: number.isRequired,
        }),
        id: string.isRequired,
      }),
    ),
  }),
  onChange: func.isRequired,
}

export default function DropdownField({ field, onChange }) {
  const [other, setOther] = useState("")
  const [selected, setSelected] = useState()

  const {
    attributes: { description, label, required, settings },
    id,
    options,
  } = field
  const inputId = `field_${id}_value`
  const sortedOptions = options.sort((a, b) => a.sequence - b.sequence)
  const hasOtherOption = settings && settings.other

  useEffect(() => {
    if (selected === "other") {
      onChange({ other }, id)
    } else {
      onChange(selected, id)
    }
  }, [onChange, other, selected])

  const handleChangeSelected = ({ target: { value } }) => {
    setSelected(value)
  }

  const handleChangeOther = ({ target: { value } }) => {
    setOther(value)
  }

  return (
    <>
      <FieldLabel text={label} {...{ required }}>
        {label}
      </FieldLabel>
      <p style={{ whiteSpace: "pre-line" }}>{description}</p>
      <div className="custom-select">
        <select
          className="select"
          id={inputId}
          onChange={handleChangeSelected}
          required={required}
          value={selected}
        >
          <option />
          {sortedOptions.map(({ attributes: { label }, id: optionId }) => (
            <option key={`field_${id}_option_${optionId}`} value={optionId}>
              {label}
            </option>
          ))}
          {hasOtherOption && <option value="other">Other</option>}
        </select>
      </div>
      {selected === "other" && (
        <div className="mt-1">
          <TextInput
            id={`field_${id}_other_value`}
            placeholder="Other"
            value={other}
            onChange={handleChangeOther}
          />
        </div>
      )}
    </>
  )
}
